import { useMemo } from 'react';

import {
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,
} from 'react-router-dom';

import { useAuth } from 'hooks';

import { MotionWrapper, MotionRedirect, AnimationType } from '.';

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  component: React.ComponentType;
  redirectPath?: string;
  roles?: string[];
  overflowHiddenMotionWrapper?: boolean;
  animationType?: AnimationType;
  hasMotionWrapper?: boolean;
}

export function Route({
  component: Component,
  overflowHiddenMotionWrapper,
  isPrivate = true,
  redirectPath = '/sign-in',
  hasMotionWrapper = true,
  animationType,
  ...rest
}: RouteProps): JSX.Element {
  const { user, token } = useAuth();

  const memoCanAccessRoute = useMemo(() => {
    return !!(user && token);
  }, [token, user]);

  const MemoWrapper = useMemo(() => {
    if (hasMotionWrapper) {
      return (
        <MotionWrapper
          overflowHidden={overflowHiddenMotionWrapper}
          animationType={animationType}
        >
          <Component />
        </MotionWrapper>
      );
    }

    return (
      <>
        <Component />
      </>
    );
  }, [Component, animationType, hasMotionWrapper, overflowHiddenMotionWrapper]);

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) =>
        memoCanAccessRoute ? (
          MemoWrapper
        ) : (
          <MotionRedirect
            to={{
              pathname: isPrivate ? redirectPath : '/',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
